<ng-container *ngIf="showTagButtonInModule">
  <button (click)="checkRecords()" id="btnOpenTags" class="btn btn-warning extras-button-padding text-white">
    <fa-icon [icon]="['fas', 'tag']" [fixedWidth]="true" aria-hidden="true"></fa-icon>
  </button>
</ng-container>

